import React from 'react';

export default () => (
	<div className='nbn-infobox--disclaimer fin-text-grey'>
		<p>The data presented may change from time to time, may not be accurate, complete, up to date, and may not have been validated. Note: nbn co and other nbn™ logos and brands are trademarks of nbn co limited and used under licence.</p>
	</div>
);
